import { Link } from "react-router-dom";
import React, { useState, useContext, useEffect } from "react";
import { UserContext } from '../UserContext';
import { useTranslation } from "../LanguageContext";

function Navbar() {
    const { user } = useContext(UserContext);
    const { t } = useTranslation();
    const [isDisabled] = useState(user.subscription.status !== "active");
    const [activeIndex, setActiveIndex] = useState(0);
    const [alert, setAlert] = useState(false);

    const handlealert = (a) => {
        if (user.subscription.status !== "active") {
            setAlert(true);
            setAlert(true);
            setTimeout(() => {
                setAlert(false);
            }, 5000);
        }
        else {
            handleClick(a);
        }
    }

    const handleClick = (a) => {
        setActiveIndex(a);
    };

    let navItems = [];

    // 1. Creator — only for creator account type
    if (user?.account_type === "creator") {
        navItems.push({
            label: "Creator",
            to: "/creator",
            disabled: isDisabled,
            isRainbow: true,
            icon: (
                <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z" />
                </svg>
            ),
        });
    }

    // 2. Finance — for all users (green dollar icon)
    if (user) {
        navItems.push({
            label: "Finance",
            to: "/finance",
            disabled: false,
            isGreen: true,
            icon: (
                <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2}>
                    <rect x="2" y="6" width="20" height="13" rx="2" strokeLinecap="round" strokeLinejoin="round" />
                    <path strokeLinecap="round" strokeLinejoin="round" d="M12 10v5M14.5 12.5c0-1.38-1.12-2.5-2.5-2.5s-2.5 1.12-2.5 2.5 1.12 2.5 2.5 2.5 2.5-1.12 2.5-2.5z" />
                </svg>
            ),
        });
    }

    // 3. Campaigns — for creator and brand account types
    if (user?.account_type === "creator" || user?.account_type === "brand") {
        navItems.push({
            label: "Campaigns",
            to: "/campaigns",
            disabled: false,
            icon: (
                <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M11 5.882V19.24a1.76 1.76 0 01-3.417.592l-2.147-6.15M18 13a3 3 0 100-6M5.436 13.683A4.001 4.001 0 017 6h1.832c4.1 0 7.625-1.234 9.168-3v14c-1.543-1.766-5.067-3-9.168-3H7a3.988 3.988 0 01-1.564-.317z" />
                </svg>
            ),
        });
    }

    // 4. Profile
    navItems.push({
        label: "Profile",
        to: "/profile",
        disabled: isDisabled,
        icon: (
            <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
            </svg>
        ),
    });

    // 5. Chats
    navItems.push({
        label: "Chats",
        to: isDisabled ? "#" : "/chats",
        disabled: isDisabled,
        icon: (
            <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
            </svg>
        ),
    });

    // 6. Search
    navItems.push({
        label: "Search",
        to: "/search",
        disabled: false,
        icon: (
            <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
            </svg>
        ),
    });

    // 7. Settings
    navItems.push({
        label: "Settings",
        to: "/settings",
        disabled: false,
        icon: (
            <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.066 2.573c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.573 1.066c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.066-2.573c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
            </svg>
        ),
    });

    useEffect(() => {
        const index = navItems.findIndex(item => item.to === window.location.pathname);
        if (index !== -1) {
            setActiveIndex(index);
        }
    }, [window.location.pathname, navItems.length]);

    return (
        <div>
            {/* Alert banner */}
            {alert && (
                <div className="fixed top-4 left-0 right-0 mx-auto w-max max-w-[90vw] text-center z-[1100] bg-red-500 text-white px-6 py-3 rounded-xl shadow-lg text-sm font-medium animate-bounce">
                    {t('nav.payAlert')}
                </div>
            )}

            {/* Bottom navigation bar */}
            <nav className="fixed bottom-6 left-1/2 -translate-x-1/2 z-[1000] w-full max-w-sm px-4">
                {/* Bluish Glass Wrapper */}
                <div className="relative bg-primary-100/30 backdrop-blur-xl border border-white/60 rounded-[32px] h-16 px-2 shadow-[0_8px_32px_rgba(37,99,235,0.15),inset_0_1px_2px_rgba(255,255,255,0.9)] overflow-hidden">
                    {/* Glass shine reflection on the top half */}
                    <div className="absolute inset-x-0 top-0 h-1/2 bg-gradient-to-b from-white/70 to-transparent opacity-50 pointer-events-none"></div>

                    <div 
                        className="grid h-full relative z-10" 
                        style={{ gridTemplateColumns: `repeat(${navItems.length}, minmax(0, 1fr))` }}
                    >
                        {navItems.map((item, index) => (
                            <Link
                                key={item.label}
                                to={item.disabled ? "#" : item.to}
                                onClick={(e) => {
                                    if (item.disabled) {
                                        e.preventDefault();
                                        handlealert(index);
                                    } else {
                                        handleClick(index);
                                    }
                                }}
                                className={`flex flex-col items-center justify-center h-full transition-all duration-300
                                    ${activeIndex === index
                                        ? "text-primary-800 -translate-y-1 drop-shadow-sm font-semibold"
                                        : "text-slate-500 hover:text-primary-600"
                                    }
                                    ${item.disabled ? "opacity-40 cursor-pointer" : ""}
                                `}
                            >
                                <span className={`relative transition-transform duration-300 ${activeIndex === index ? "scale-110" : ""} ${item.isRainbow ? "animate-rainbow" : ""} ${item.isGreen ? "text-green-500 drop-shadow-[0_0_8px_rgba(34,197,94,0.8)]" : ""}`}>
                                    {item.icon}
                                    {item.label === "Chats" && user?.notifications?.length > 0 && activeIndex !== index && (
                                        <span data-testid="chats-unread-dot" className="absolute -top-1 -right-1 flex h-3 w-3 items-center justify-center">
                                            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75"></span>
                                            <span className="relative inline-flex rounded-full h-3 w-3 bg-red-500 border-2 border-white"></span>
                                        </span>
                                    )}
                                </span>
                            </Link>
                        ))}
                    </div>

                    {/* Active indicator dot - styled to match bluish glow */}
                    <div
                        className="absolute bottom-1.5 h-1 w-8 bg-gradient-to-r from-primary-400 to-primary-600 rounded-full transition-all duration-300 shadow-[0_2px_6px_rgba(37,99,235,0.5)] z-10"
                        style={{
                            left: `calc(8px + (100% - 16px) * (${activeIndex} * ${1 / navItems.length} + ${1 / (2 * navItems.length)}) - 16px)`
                        }}
                    />
                </div>
            </nav>
        </div>
    )
}
export default Navbar;